import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormulariosService } from 'src/app/services/formularios.service';
@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

  public sent: boolean = false;
  contactForm: FormGroup;

  error: boolean = false;
  errorText: string = "Comprueba todos los campos.";

  constructor(private formBuilder: FormBuilder, private formularioService: FormulariosService) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      title: ['', [Validators.required]],
      event: [''],
      category: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
  }


  send() {
    if (this.contactForm.invalid) {
      this.error = true;
      this.errorText = "Comprueba todos los campos.";
      return;
    }
    if (this.contactForm.value.category == 'problemas_con_mi_entrada' && !this.contactForm.value.event) {
      this.error = true;
      this.errorText = "Por favor, especifica el evento.";
      return;
    }

    var message = JSON.stringify(this.contactForm.value);
    this.formularioService.sendMessage(message).subscribe({
      next: (response: any) => {
        if (response && response.success === true) {
          this.sent = true;
          return;
        }
        this.error = true;
        this.errorText = "Ha ocurrido un error al enviar el formulario. Inténtalo de nuevo más tarde.";
        if (response.errors == 'user_not_found') {
          this.errorText = "Asegúrate de que el correo electrónico pertenece a un usuario registrado.";
        }
      },
      error: (err) => {
        this.error = true;
        this.errorText = "Ha ocurrido un error al enviar el formulario. Inténtalo de nuevo más tarde.";
      }
    });
  }
}
